/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosText, EdsIcon } from "@cosmos/components";
import { ResellersSearchSectionFragment } from "@cosmos/hygraph-schema";
import { css } from "@panda/css";
import { VStack } from "@panda/jsx";
import { useMemo } from "react";

const magnifierStyle = css({
	display: "flex",
	justifyContent: "center",
	"& svg": {
		width: "eds.dimension.64!important",
		height: "eds.dimension.64!important",
	},
});

type ResellersSearchNoResultsProps = Pick<ResellersSearchSectionFragment, "noResultsLabel"> & {
	searchValue?: string | null;
};

export const ResellersSearchNoResults = ({
	searchValue,
	noResultsLabel,
}: ResellersSearchNoResultsProps): React.JSX.Element => {
	const finalLabel = useMemo(
		() => noResultsLabel?.replace("{searchValue}", searchValue || "") || "",
		[searchValue, noResultsLabel],
	);
	return (
		<VStack gap="eds.dimension.32" paddingBlock="eds.dimension.40" width="full">
			<div className={magnifierStyle}>
				<EdsIcon icon="Magnifier" gradient="blue" size="xl" />
			</div>
			<CosmosText variant="headingXL">{finalLabel}</CosmosText>
		</VStack>
	);
};
